import axios from "axios";
import React, { useState } from "react";

function Verify() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [verified, setVerified] = useState(false);
  const [otp, setOtp] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handleVerify = () => {
    if (mobileNumber.length === 10) {
      // Simulating a verification process
      setVerified(true);
      const requestData = {
        phone: mobileNumber,
        deviceId: "76876585866875858",
      };
      try {
        const response = axios.post(
          "api/userservice/authentication/generate-otp",
          requestData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);
      } catch (error) {
        console.log(error, error.message);
      }
    } else {
      alert("Please enter a valid 10-digit mobile number");
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleOtpSubmit = () => {
    if (otp.length === 6) {
      const requestData = {
        type: "OTP",
        userType: "CUSTOMER",
        phone: mobileNumber,
        otp: otp,
      };
      try {
        const response = axios.post(
          "api/userservice/authentication/verify-otp",
          requestData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response.data);
      } catch (error) {
        console.log(error)
      }
    } else {
      alert("Please enter a valid 6-digit OTP");
    }
  };

  return (
    <div className="pt-24 flex justify-center pl-2 pr-2 w-full h-screen">
      <div className="pt-5 w-full justify-center md:w-[60%]">
        <div className="flex justify-center pb-10">
          <h1 className="text-2xl font-semibold">Verify</h1>
        </div>

        {!verified ? (
          <div className="w-full">
            <h1 className="text-xl font-semibold text-[#171725] ">
              Enter Mobile Number
            </h1>
            <p className="pt-4 text-lg pb-4 text-[#8F8F97]">
              Verify your mobile number to make payment and complete your order
            </p>

            {/* Input field for mobile number */}
            <div className="flex border border-gray-300 rounded-2xl text-lg px-3 py-3 w-full items-center justify-center">
            <div className="pr-2">
              <h1 className="tracking-wide">+91</h1>
            </div>
            <input
              type="text"
              value={mobileNumber}
              onChange={handleInputChange} // Updates the state with input value
              placeholder="Enter your mobile number"
              className="w-full h-10 border-none focus:outline-none tracking-wide"
            />
            </div>

            {/* Button to trigger the verification process */}
            <button
              onClick={handleVerify} // Verifies the number on button click
              className="w-full bg-[#FBC02D] text-[#FFFFFF] text-lg px-3 py-3 mt-4 rounded-2xl"
            >
              Next
            </button>
          </div>
        ) : (
          <div>
            <h1 className="text-xl font-semibold text-[#171725]">Enter OTP</h1>
            <p className="pt-4 text-lg pb-4 text-[#8F8F97]">
              We have sent SMS to{" "}
              <b className="text-[#171725]">{mobileNumber}</b>
            </p>

            {/* OTP input field */}
            <input
              type="text"
              value={otp}
              onChange={handleOtpChange} // Updates the OTP state with input value
              placeholder="Enter OTP"
              className="border border-gray-300 rounded-2xl text-lg px-3 py-3 w-full"
            />
            <div className="w-full flex justify-between pt-1 md:pt-2">
              <button className="text-[#8F8F97] text-base ">Change Number</button>
              <button className="text-[#FBC02D] text-base">Resend Code</button>
            </div>

            {/* Button to submit the OTP */}
            <button
              onClick={handleOtpSubmit} // Verifies the OTP on button click
              className="w-full bg-[#FBC02D] text-[#FFFFFF] text-lg px-3 py-3 mt-4 rounded-2xl"
            >
              Verify
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Verify;
